import { render, staticRenderFns } from "./FacilityEditTabAccount.vue?vue&type=template&id=46936c88"
import script from "./FacilityEditTabAccount.vue?vue&type=script&lang=js"
export * from "./FacilityEditTabAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports